import type { RequestParameters } from 'relay-runtime';

import { RETRY_ATTEMPTS_LIMIT } from './RETRY_ATTEMPTS_LIMIT';

export const getRetryAttemptsForQuery = (request: RequestParameters): 1 | 0 => {
	if (request.operationKind === 'query') {
		return RETRY_ATTEMPTS_LIMIT;
	}

	return 0;
};
